import { lazy } from 'react';

const Dashboard = lazy(() => import('./AgentDashboardPage'));

const AgentDashboardConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'agent/dashboard',
      element: <Dashboard />,
    },
  ],
};

export default AgentDashboardConfig;
